import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { SButton, SContainer } from "../../components/BasicComponents";
import AppNavbar from "../../components/Navbars/AppNavbar";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  const { t } = useTranslation("", { keyPrefix: "error.401" });

  return (
    <SContainer className="d-flex flex-column" fluid fill="true" dark="true">
      <AppNavbar dark="true" />
      <Styles>
        <h1 className="text-center mb-3 text-uppercase">{t("unauthorized")}</h1>
        <p className="text-center">{t("no_access")}</p>
        <p className="text-center">{t("please_login")}</p>
        <Link to="/">
          <SButton dark="true" className="text-center text-uppercase" size="md">
            {t("continue")}
          </SButton>
        </Link>
      </Styles>
    </SContainer>
  );
};

const Styles = styled.div`
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: var(--text-primary-dark) !important;
  }
`;

export default ErrorPage;
